module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 28@2x.340e3527.png";